var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 0H6C2.6 0 0 2.6 0 6V34C0 37.4 2.6 40 6 40H34C37.4 40 40 37.4 40 34V6C40 2.6 37.4 0 34 0ZM20 8C23 8 25.6 10.4 25.6 13.6C25.6 16.8 23.2 19.2 20 19.2C16.8 19.2 14.4 16.8 14.4 13.6C14.4 10.4 17 8 20 8ZM29.2 31.8C29 31.8 28.8 32 28.4 32H11.4C10.2 32 9.4 31 9.4 30C9.4 29.8 9.4 29.6 9.6 29.2C11.8 23.4 18.2 20.6 24 22.8C27 24 29.2 26.2 30.4 29.2C30.8 30.4 30.2 31.4 29.2 31.8Z",
    fill: "#1c8097"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.76da1c0961502c3d2bb6ba4cbca9426a.svg";
export { ForwardRef as ReactComponent };